import React, {useEffect, useState} from "react";
import {getContact, getContent} from "../api/requests";
import {LoadingMessage} from "./LoadingMessage";

export function ContentSuggestion({text, id}: ({ text: string, id: number })): React.ReactElement {
    const [content, setContent] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadContent() {
            try {
                const data = await getContent( id );
                setContent(data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        loadContent();
    }, [id]);

    console.log(content);

    if ( loading ) {

        return <LoadingMessage/>;
    }

    return (
        <>
            <p>{text}</p>
            <div className="wvcb-card wvcb-card--content-suggestion">
                <article className="wvcb-content">
                    <a className="wvcb-content__link" href={content.permalink} rel="noopener noreferrer"></a>
                    <div className="wvcb-content__image" style={{backgroundImage: `url(${content.thumbnail_url})`}}></div>
                    <p className="wvcb-content__title">{content.title}</p>
                    <p className="wvcb-content__description">{content.excerpt}</p>
                </article>
            </div>
        </>
    );
}
